module.exports = __webpack_public_path__ + "img/gu.289a25be.png";